/**
 * Remove all occurrences of "|", ";" and "!", because they have a special meaning in the event data of a pixel.
 * @param {string} string
 * @returns {string} string without special characters
 */
export function removeSpecialCharactersForEdwPixel(string = '') {
  return string.replace(/[|;!]/g, '');
}
